import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BpCoreModule } from '@bp-core/src/lib/bp-core.module';
import { ICustomCategoryFund } from '@bp-core/src/lib/models/portal/goal/custom-category-fund.model';
import { ICustomFund } from '@bp-core/src/lib/models/portal/goal/fund-custom.model';
import { FundingModel } from '@bp-core/src/lib/proto/common-message.pb';
import { environment } from '@environment/environment';
import { fuseAnimations } from '@fuse/animations';
import { GoalFundingService } from 'bp/shared/services/goal-funding.service';
import { FundsDetailSearchFundsComponent } from '../funds-detail-search-funds/funds-detail-search-funds.component';

@Component({
  selector: 'search-funds-drawer',
  templateUrl: './search-funds-drawer.component.html',
  styleUrls: ['./search-funds-drawer.component.scss'],
  animations: fuseAnimations,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    BpCoreModule,
    MatRippleModule,
    MatDividerModule,
    FundsDetailSearchFundsComponent,
  ],
})
export class SearchFundsDrawerComponent implements OnInit, OnChanges {
  searchForm: UntypedFormGroup;
  subCategoryWithFundsAddedTmp: ICustomCategoryFund[] = [];
  subCategoryWithFundsFiltered: ICustomCategoryFund[] = [];
  customCategorySelected: ICustomCategoryFund;
  currentPage = 'category-list';
  lastPage = 'category-list ';
  customFundSelected: ICustomFund;
  urlFileBase = environment.urlApiV2 + 'api/Files/';
  token = localStorage.getItem('access_token');

  @Input() drawerOpened = false;
  @Input() isFundingDetail = false;
  @Input() funding: FundingModel | undefined;

  @Input() subCategoryWithFundsAdded: ICustomCategoryFund[] = [];

  @Input() subCategoryWithFunds: ICustomCategoryFund[];

  @Output() close = new EventEmitter<void>();

  @Output() onAddCategoryFund = new EventEmitter<ICustomCategoryFund>();
  @Output() onRemoveCategoryFund = new EventEmitter<ICustomCategoryFund>();
  @ViewChild('backButton') private backButton: ElementRef;

  get startPage() {
    return this.currentPage === 'category-list';
  }

  get search() {
    return this.searchForm?.get('search');
  }

  constructor(
    private fb: UntypedFormBuilder,
    public goalFundingService: GoalFundingService,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.subCategoryWithFundsAdded?.currentValue) {
      this.subCategoryWithFundsAddedTmp = [...this.subCategoryWithFundsAdded];
    }
    if (changes.subCategoryWithFunds?.currentValue) {
      this.subCategoryWithFundsFiltered = [...this.subCategoryWithFunds];
    }
    if (changes.drawerOpened?.currentValue) {
      this.currentPage = 'category-list';

      this.subCategoryWithFundsFiltered = [...this.subCategoryWithFunds];
      this.search?.setValue('');
    }
    if (this.isFundingDetail === true) {
      this.currentPage = 'fund-detail';
    } else {
      this.currentPage = 'category-list';
    }
  }
  ngOnInit(): void {
    this.searchForm = this.fb.group({
      search: '',
    });

    this.searchForm.valueChanges.subscribe(() => {
      this.filterSubCategoryWithFunds();
    });
  }
  filterSubCategoryWithFunds() {
    const filterValue = this.search?.value.toLowerCase();

    this.subCategoryWithFundsFiltered = this.subCategoryWithFunds
      .map(subCategoryWithFunds => {
        // Filtrar los customFunds que coinciden
        const matchingCustomFunds = subCategoryWithFunds.customFunds.filter(
          customFund =>
            customFund.fund.fund?.title.toLowerCase().includes(filterValue) ||
            customFund.fund.fund?.mnemonic.toLowerCase().includes(filterValue),
        );

        return {
          ...subCategoryWithFunds,
          // Verificar si la categoría o alguno de los customFunds coinciden
          customFunds: subCategoryWithFunds.category.categoryDisplayName
            .toLowerCase()
            .includes(filterValue)
            ? subCategoryWithFunds.customFunds // Si la categoría coincide, mantener todos los customFunds
            : matchingCustomFunds, // De lo contrario, usar solo los customFunds coincidentes
        };
      })
      .filter(
        subCategoryWithFunds =>
          subCategoryWithFunds.category.categoryDisplayName.toLowerCase().includes(filterValue) ||
          subCategoryWithFunds.customFunds.length > 0,
      );
  }

  selectCustomFund(customFund: ICustomFund) {
    this.customFundSelected = customFund;
  }
  selectCategory(customCategory: ICustomCategoryFund) {
    this.customCategorySelected = customCategory;
    this.customCategorySelected.customFunds.sort((a: ICustomFund, b: ICustomFund) => {
      // Proporciona un valor predeterminado para los títulos en caso de que sean undefined
      const titleA = a.fund.fund?.title || '';
      const titleB = b.fund.fund?.title || '';

      return titleA.localeCompare(titleB);
    });
  }
  back() {
    if (this.isFundingDetail) {
      this.close.emit();
      return;
    }

    switch (this.currentPage) {
      case 'fund-detail':
        if (this.lastPage === 'category-list') {
          this.currentPage = 'category-list';
          break;
        }
        this.currentPage = 'funds-list';

        break;
      case 'funds-list':
        this.currentPage = 'category-list';

        break;
      case 'category-list':
        this.close.emit();
        break;
    }
    this.lastPage = this.currentPage;
  }
  next(route?: string) {
    this.lastPage = this.currentPage;
    this.backButton.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (route) {
      this.currentPage = route;
      return;
    }

    switch (this.currentPage) {
      case 'category-list':
        this.currentPage = 'funds-list';

        break;
      case 'funds-list':
        this.currentPage = 'fund-detail';

        break;
      case 'fund-detail':
        this.addCustomCategoryFund(this.customFundSelected);
        this.currentPage = 'funds-list';

        break;
    }
  }

  addCustomCategoryFund(customCategoryFund: ICustomFund) {
    if (!this.isCustomFundAdded(customCategoryFund)) {
      this.subCategoryWithFundsAddedTmp.push({
        category: customCategoryFund.category!,
        customFunds: [customCategoryFund],
      });
    }

    this.onAddCategoryFund.emit({
      category: customCategoryFund.category!,
      customFunds: [customCategoryFund],
    });
  }
  removeCustomCategoryFund(customFund: ICustomFund) {
    const customCategoryFund = this.subCategoryWithFundsAddedTmp.find(
      customCategoryFund =>
        customCategoryFund.category.categoryId === customFund.category?.categoryId,
    );
    if (customCategoryFund) {
      customCategoryFund.customFunds = customCategoryFund.customFunds.filter(
        cf => cf.fund.fund?.id !== customFund.fund.fund?.id,
      );
      if (customCategoryFund.customFunds.length === 0) {
        this.subCategoryWithFundsAddedTmp = this.subCategoryWithFundsAddedTmp.filter(
          cf => cf.category.categoryId !== customCategoryFund.category.categoryId,
        );
      }
    }
    this.onRemoveCategoryFund.emit({
      category: customFund.category!,
      customFunds: [customFund],
    });
  }
  isCustomFundAdded(customFund?: ICustomFund) {
    if (this.isFundingDetail) {
      return this.subCategoryWithFundsAddedTmp.some(customFundAdded =>
        customFundAdded.customFunds.some(cf => cf.fund.fund?.id === this.funding?.id),
      );
    }
    return this.subCategoryWithFundsAddedTmp.some(customFundAdded =>
      customFundAdded.customFunds.some(cf => cf.fund.fund?.id === customFund?.fund.fund?.id),
    );
  }
  goShowBrochure(fund: FundingModel) {
    if (fund?.informativeBrochureUrl !== '') {
      window.open(fund?.informativeBrochureUrl!, '_blank', 'noopener');
      return;
    }
    window.open(
      this.urlFileBase + fund?.informativeBrochureId?.value + '/?token=' + this.token,
      '_blank',
      'noopener',
    );
  }
}
